import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import _ from "lodash";
import { useStaticQuery, graphql} from "gatsby"
import loadable from "@loadable/component"
import GuidesListBanner from "gatsby-theme-starberry-lomondgroup/src/components/GuidesListBanner/GuidesListBanner";


import GuidesCard from "gatsby-theme-starberry-lomondgroup/src/components/GuidesResources/GuidesCard";
import "gatsby-theme-starberry-lomondgroup/src/components/GuidesResources/GuidesResources.scss"
import CustomPagination from "gatsby-theme-starberry-lomondgroup/src/components/CustomPagination/CustomPagination";

const ReactPaginate = loadable(() => import("react-paginate"));

const GuidesList = ({ Module }) => {

    //let window_wdth = typeof window !== "undefined" && window.innerWidth;

    const data = useStaticQuery(graphql`
        query GuidesQueryCustom{
          glstrapi {

            guidesCategories(sort: "rank:ASC") {
                id
                category_name
                rank
            }

            guidesAndResources(sort:"createdAt:desc", publicationState: LIVE) {
                id
                title
                slug
                guides_categories {
                    id
                    category_name
                }
                image {
                    url
                    alternativeText
                }
                imagetransforms
                ggfx_results {
                    id
                    content_type
                    transforms
                    src_import_url
                    src_cftle
                    field
                }
            }
          }
        }`)
  
    var guidesList = data.glstrapi?.guidesAndResources;
    var guidesCategory = data.glstrapi?.guidesCategories;
    const categories = guidesCategory;

    const [set, setClass] = useState(false);
    const handleShow = () => {
        setClass(!set);
    }

    const [filter, setFilter] = useState('all_guides');
    let [projects, setProjects] = useState(guidesList);
    let [filteredList, setFilteredList] = useState(guidesList);
    const [pageCount, setPageCount] = useState(0);
    let itemsPerPage = 12;
    const [itemOffset, setItemOffset] = useState(0);
    const [cusrrentPage, setCurrentPage] = useState(0);
    const width = typeof window !== "undefined" &&  window.innerWidth

    let index_no = 5;
    if(width > 991 && width < 1200){
        index_no = 5;
        itemsPerPage = 12;
    }

    const newClass = (event) => {
        var parent = document.getElementById('filter-link');
        parent.classList.add('filter-active');
        setClass(false);
        var allChildElements = parent.querySelectorAll('.link-btn');
        for (const box of allChildElements) {
            box.classList.remove('active');
        }
        event.target.classList.add('active')
    }

    const applyCategory = (filt) => {
        setItemOffset(0)
        if (filt !== "all_guides") {
            setProjects([]);
            const filtered = _.filter(guidesList, function (o) { return o.guides_categories.some(item2 => item2.category_name.replace(/_/gi, ' ') === filt || item2.id === filt) });
            setProjects(filtered);
            setFilteredList(filtered);
        } else {
            setProjects(guidesList);
            setFilteredList(guidesList);
        }
    }

    useEffect(() => {
        if (!projects.length) {
            setFilteredList([]);
            setPageCount(0);
            return;
        }

        const endOffset = itemOffset + itemsPerPage;
        setFilteredList(projects.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(projects.length / itemsPerPage));
        setCurrentPage(Math.floor(itemOffset / itemsPerPage));
    }, [itemOffset, itemsPerPage, projects]);

    const handlePageClick = (selectedPage) => {
        const newOffset = selectedPage * itemsPerPage;
        setItemOffset(newOffset);
        setCurrentPage(selectedPage);
        setTimeout(() => window.scrollTo(0, 200), 100);
    };

   //console.log("pageCount ==>", pageCount)

    return (
        <>
            <section className="category">
                <Container>
                    <Row>
                        <Col>
                            <div className="category-wrap new-wrap">
                                <button onClick={handleShow}>{filter.replace(/_/g,' ')}
                                    <i className="icon-dropdown"></i>
                                </button>

                            </div>
                            <div id="filter-link" className={set ? "category-wrap news-category open-category" : "category-wrap news-category"}>
                                <button className={filter === "all_guides" ? "link-btn active" : "link-btn"} onClick={(event) => {
                                    setFilter("all_guides"); applyCategory("all_guides"); newClass(event);
                                }}>All Guides</button>

                                {categories?.map((item, index) => (
                                    <button key={index} className={filter === item.category_name.replace(/_/gi, ' ') ? "link-btn active" : "link-btn"} onClick={(event) => {
                                        setFilter(item.category_name.replace(/_/gi, ' ')); applyCategory(item.id); newClass(event);
                                    }}>{item.category_name.replace(/_/gi, ' ')} </button>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>


            <section className="guide-card">
                <Container>
                    <Row>
                        <Col>
                            {filteredList.length > 0 ? 
                                <div className="card-wrapper row">
                                    {filteredList?.map((item, index) => {
                                        return (
                                            <>
                                                <Col md={6} xl={4}>
                                                    <div className="card-box"><GuidesCard item={item} imagename={"guides-and-resources.image.card_image"} /></div>
                                                </Col>

                                            
                                                {index === index_no ?
                                                <Col md={12}><GuidesListBanner /></Col>
                                                : null
                                                }
                                            </>
                                            
                                        )
                                    })}
                                </div>
                            : 
                                <p className="text-center">No guides and resources found.</p>
                            }
                            {pageCount > 1 &&
                                <div className="pagination-section">
                                    {/* <ReactPaginate
                                        breakLabel="..."
                                        nextLabel="next >"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={pageCount}
                                        previousLabel="< previous"
                                        renderOnZeroPageCount={null}
                                        className="pagination"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="prev page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="next page-item"
                                        nextLinkClassName="page-link"
                                        activeClassName="active"
                                    /> */}

                                    <CustomPagination 
                                    total={guidesList?.length} 
                                    current_page_number={cusrrentPage} 
                                    hitsPerPage={itemsPerPage} 
                                    nbPages={pageCount} 
                                    handlePageClick={handlePageClick}/>
                                </div>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
};
export default GuidesList;
